import React from "react";

import Button from "../form/Button";
import DropdownButton from "../form/DropdownButton";
import FilterList from "material-ui/svg-icons/action/search";
import { ExportButton } from "./exportGrid";

import Filters from "./Filters";
import Summary from "./Summary";

export default class Caption extends React.Component {
  state = {
    askRemove: false,
  };

  componentDidMount() {
    const { filterAlways, filters, filterOpen, onFilterAdd, onFilterOpen } = this.props;
    if(filterAlways) {
      if (!filterOpen && (!filters || filters.length === 0)) {
        onFilterAdd();
      }
      onFilterOpen(true);
    }
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.selected !== prevProps.selected) {
      this.setState({ askRemove: false });
    }
  };

  handleFilterOpenClick = () => {
    const {
      filterOpen,
      onFilterOpen,
      onFilterResetValues,
      filters,
      onFilterAdd,
    } = this.props;

    if (!filterOpen && (!filters || filters.length === 0)) {
      onFilterAdd();
    }

    onFilterOpen(!filterOpen);
    if (filterOpen) {
      onFilterResetValues();
    }
  };

  handleEdit = () => {
    const { selected, onEdit } = this.props;

    if (selected.length !== 1) {
      throw Error("Wrong number of selected items.");
    }

    onEdit(selected[0]);
  };

  handleMultipleEdit = () => {
    const { selected, onEdit } = this.props;
    onEdit(selected);
  };

  handleCheckAction = () => {
    const { onCheckAction, selected } = this.props;
    onCheckAction(selected);
  };

  handleRemove = () => {
    const { selected, onRemove } = this.props;

    onRemove(selected);
  };

  handleCheckboxFn = () => {
    const { selected, onCheckboxFn, items } = this.props;
    const selectedItems = items.filter(item => selected.includes(item.id) ? item : null);

    onCheckboxFn(selected, selectedItems);
  };

  handleMoreCheckboxFn = (fn) => {
    const { selected, onMoreCheckboxFn } = this.props;
    onMoreCheckboxFn(fn, selected);
  };

  askAction = () => {
    this.setState({ askRemove: !this.state.askRemove });
  };

  render() {
    const {
      adding,
      editing,
      deleting,
      hidding,
      deletingText = "Smazat",
      filtering,
      filterAlways,
      selected,
      onAdd,
      toolbarButtons,
      addButtonStyle,
      onCheckAction,
      checkActionLabel,
      filterOpen,
      showPaging,
      helpEnumAdd,
      fnText,
      moreCheckboxFns,
      moreCheckboxFnsItems,
      otherCheckboxFns,
      editText,
      editMultiple = false,
    } = this.props;

    if (
      !onCheckAction &&
      !adding &&
      !hidding &&
      !editing &&
      !deleting &&
      toolbarButtons.length === 0 &&
      !filtering &&
      !filterAlways &&
      !filterOpen &&
      !showPaging &&
      !moreCheckboxFns &&
      !otherCheckboxFns
    ) {
      return null;
    }

    return (
      <div>
        <div className="buttonBar main">
          {hidding ? (
            <Button
              className="primary"
              onTouchTap={onAdd}
              style={addButtonStyle}
            >
              Skrýt historii
            </Button>
          ) : null}

          {(filtering || filterAlways) && (
            <Button
              className="primary"
              onTouchTap={this.handleFilterOpenClick}
              aria-label="Filtrovat"
              style={{
                minWidth: 45,
                height: 45,
                borderRadius: 25,
                lineHeight: 0,
                marginRight: 15,
              }}
            >
              <FilterList color="white" />
            </Button>
          )}
          {filtering && this.props.url && (
            <ExportButton
              url={this.props.url}
              columns={this.props.columns}
              gridName={this.props.gridName}
              exportFileName={this.props.exportFileName}
            />
          )}

          {onCheckAction && selected.length > 0 ? (
            <Button className="primary" onTouchTap={this.handleCheckAction}>
              {checkActionLabel}
            </Button>
          ) : null}
          {adding ? (
            helpEnumAdd ? (
              <Button
                className="primary"
                onTouchTap={onAdd}
                style={addButtonStyle}
                label="Přidat"
                helpEnum={helpEnumAdd}
                tooltipPosition="bottom-right"
              />
            ) : (
              <Button
                className="primary"
                onTouchTap={onAdd}
                style={addButtonStyle}
              >
                Přidat
              </Button>
            )
          ) : null}

          {editing && editMultiple && selected.length === 1 ? (
            <Button
              className="primary"
              onTouchTap={this.handleEdit}
              style={addButtonStyle}
            >
              {editText !== "" ? editText : "Upravit"}
            </Button>
          ) : null}

          {editing && editMultiple && selected.length > 1 ? (
            <Button
              className="primary"
              onTouchTap={this.handleMultipleEdit}
              style={addButtonStyle}
            >
              {editText !== "" ? editText : "Upravit"}
            </Button>
          ) : null}

          {deleting && selected.length > 0 ? (
            <Button
              className="primary"
              onTouchTap={
                deletingText === "Smazat" ? this.askAction : this.handleRemove
              }
              style={addButtonStyle}
            >
              {deletingText}
            </Button>
          ) : null}

          {moreCheckboxFns && !moreCheckboxFnsItems && selected.length > 0 ? (
            <Button
              className="primary"
              onTouchTap={this.handleCheckboxFn}
              style={addButtonStyle}
            >
              {fnText}
            </Button>
          ) : null}

          {moreCheckboxFns && moreCheckboxFnsItems && selected.length > 0 ? (
            <DropdownButton
              type="button"
              style={{...addButtonStyle, marginRight: 10}}
              options={moreCheckboxFnsItems.map(opt => ({
                ...opt,
                onClick: () => opt.onClick(selected)
              }))}
            >
              {fnText}
            </DropdownButton>
          ) : null}

          {otherCheckboxFns && selected.length > 0 ?
            otherCheckboxFns.map((fn, index) => {
              return (
                <Button
                  key={index}
                  className="primary"
                  onTouchTap={() => fn.onClick(selected)}
                  style={addButtonStyle}
                >
                  {fn.label}
                </Button>
              )
            }
          ) : null}

          {toolbarButtons}
        </div>

        <div
          className={
            this.state.askRemove ? "deleteBox opened" : "deleteBox closed"
          }
        >
          <div style={{ marginBottom: 8, color: "#000000" }}>
            Opravdu chcete smazat vybrané položky?
          </div>
          <Button
            className="primary"
            onTouchTap={this.handleRemove}
            style={addButtonStyle}
            disabled={!this.state.askRemove}
          >
            Ano
          </Button>
          <Button
            className="primary"
            onTouchTap={this.askAction}
            style={addButtonStyle}
            disabled={!this.state.askRemove}
          >
            Ne
          </Button>
        </div>

        {filterOpen && <Filters {...this.props} />}
      </div>
    );
  }
}
